export default {
    namespaced: true,
    state: {
        id: 0,
        name: '',
        roleType: 1
    },
    mutations: {
        updateId(state, id) {
            state.id = id
        },
        updateName(state, name) {
            state.name = name
        },
        updateRoleType(state, roleType) {
          state.roleType = roleType
      },
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js